<script setup lang="ts"></script>

<template>
    <h1>Доступ запрещён</h1>
</template>

<style scoped></style>
